module.exports = __webpack_public_path__ + "static/media/71.0551948.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/71.wav
// module id = lvXO
// module chunks = 0